import api from '../index'

const {
  http,
  advancedSearch
} = api

/**
 * ===================
 * IT Certificate API
 * ===================
 */
export default {
  baseUrl: `${process.env.VUE_APP_COMMON_URL}/api/v1`,
  url: 'it-certificates',
  http,
  advancedSearch
}
